const ContactType = {
  EMAIL: "EMAIL",
  MOBILE: "MOBILE",
};

export { ContactType };
